// node:module のブラウザ代替。lib/validate-schema.mjs が createRequire(gameDir/package.json)('ajv')
// でゲームの ajv を解決する経路のみをサポートする。ajv はバンドルへ inline される
// （esbuild nodePaths=sevenfold/node_modules で解決。実証済み）。
import Ajv from 'ajv';

// ajv 8.x は CJS（module.exports = Ajv, exports.default = Ajv）。ESM default import の相互運用差を吸収。
const AjvClass = (Ajv && Ajv.default) ? Ajv.default : Ajv;

export function createRequire() {
    return (id) => {
        if (id === 'ajv') return AjvClass;
        throw new Error(`createRequire shim: モジュール '${id}' はブラウザでは解決できません`);
    };
}

export default { createRequire };
